var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialPost(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M5 21.75a1.81 1.81 0 0 1-.78-.18 1.74 1.74 0 0 1-1-1.57V3A1.76 1.76 0 0 1 5 1.25h14A1.76 1.76 0 0 1 20.75 3v17A1.75 1.75 0 0 1 18 21.4l-5.8-4.35a.24.24 0 0 0-.3 0L6.05 21.4a1.77 1.77 0 0 1-1.05.35zm0-19a.25.25 0 0 0-.25.25v17a.24.24 0 0 0 .14.22.23.23 0 0 0 .26 0L11 15.85a1.77 1.77 0 0 1 2.1 0l5.8 4.35a.23.23 0 0 0 .26 0 .24.24 0 0 0 .14-.22V3a.25.25 0 0 0-.3-.25z",
    opacity: 1,
    "data-original": "#232323",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M15 7.75H9a.75.75 0 0 1 0-1.5h6a.75.75 0 0 1 0 1.5z",
    opacity: 1,
    "data-original": "#7fbde7",
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialPost);
export default __webpack_public_path__ + "static/media/social-post.0500436265450eb42506ba78306db17e.svg";
export { ForwardRef as ReactComponent };